import { serviceIconPaths } from "./serviceIcons";

export type MigrationService = {
  title: string;
  description: string;
  icon: string;
  backgroundImage?: string;
  videoUrl?: string;
  url?: string;
};

export const migrationServicesHeading = "Australia Migration\nServices";

export const migrationServicesSubheading =
  "Hola World Migration Australia is a migration-focused consultancy dedicated to helping individuals and families build a future in Australia through reliable PR and visa pathways.";

export const migrationServices: MigrationService[] = [
  {
    title: "Skilled Visas",
    description:
      "Expert consultation on permanent residency pathways, eligibility assessment, and guidance through the Australian PR application process.",
    icon: serviceIconPaths.skilledVisas,
    backgroundImage: "/assets/services-cards/images/skilled-visas.jpg",
    url: "/skilled-visas-australia",
  },
  {
    title: "Skills Assessment",
    description:
      "Comprehensive assistance with skill assessments, including document preparation, authority selection, and migration pathway planning.",
    icon: serviceIconPaths.skillsAssessment,
    backgroundImage: "/assets/services-cards/images/skills-assessment.jpg",
    url: "/australia-skills-assessment",
  },
  {
    title: "Employer-Sponsored Visas",
    description:
      "Complete support for employer-sponsored pathways, including TSS 482, ENS 186, and other sponsored migration options.",
    icon: serviceIconPaths.employerSponsored,
    backgroundImage: "/assets/services-cards/images/employer-sponsored-visas.jpg",
    url: "/employer-sponsored-visas-australia",
  },
  {
    title: "Family and Partner Visas",
    description:
      "Reunite your loved ones in Australia with expert guidance on spouse, partner, parent, and dependent visa applications.",
    icon: serviceIconPaths.familyPartner,
    backgroundImage: "/assets/services-cards/images/family-partner-visas.jpg",
    url: "/family-partner-visas-australia",
  },
  {
    title: "Visitor & Tourist Visas",
    description:
      "Hassle-free support for visitor visas, tourist visas, and short-term travel to Australia for family visits or holidays.",
    icon: serviceIconPaths.visitorTourist,
    backgroundImage: "/assets/services-cards/images/visitor-tourist-visas-01.jpg",
    url: "/visitor-tourist-visas-australia",
  },
  {
    title: "Corporate Immigration",
    description:
      "Tailored corporate migration solutions for businesses, including workforce mobility, sponsorship guidance, and global talent acquisition support.",
    icon: serviceIconPaths.corporateImmigration,
    backgroundImage: "/assets/services-cards/images/corporate-immigration.jpg",
    url: "/corporate-immigration-services-australia",
  },
];
